import { reduxForm } from 'redux-form';
import Component from './EditMerchantForm';
import { validate, initialValues } from './schema';

const EditMerchantForm = reduxForm({
  form: 'formEditMerchant',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default EditMerchantForm;
